import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helpersNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import StatePositionConstant from "./../StatePositionConstant";
import AllPositions from "./../AllPositions";
import ButtonDisable from "../../../partials/other/ButtonDisable";

export default function ViewPositions() {
  const history = useHistory();
  const params = useParams();
  const positionID = params.positionID;
  let position = AllPositions.filter((position) => position.ID == positionID);
  position = position[0];
  const [checkedAgreeSuggestion, setCheckedAgreeSuggestion] = useState(false);

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.PENDING
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.CONFIRM
      ]:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const generateHtmlTagForAgreeOperatorSuggestion = () => {
    return (
      <>
        <form className="py-2">
          <div className="alert alert-primary">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              پیشنهاد هایلات :{" "}
            </p>
            <p className="text-justify" style={{ whiteSpace: "pre-line" }}>
              {position.message}
            </p>
          </div>
          <div className="pb-2">
            <span className="pl-2">
              <input
                type="checkbox"
                className="hover"
                required
                onChange={() => {
                  setCheckedAgreeSuggestion((prevState) => !prevState);
                }}
                defaultChecked={() => checkedAgreeSuggestion && "checked"}
              />
            </span>
            <span>من این شرایط را قبول دارم و تخفیف ها رو می پذیرم</span>
          </div>
          <div>
            <span>
              <ButtonDisable
                buttonTagHtml={
                  <span className="btn btn-primary opacity-50">
                    قبول کردن پیشنهاد
                  </span>
                }
              ></ButtonDisable>
            </span>
          </div>
          <hr />
        </form>
        <form>
          <div className="form-group">
            <label>در صورت رد کردن پیشنهاد حتما دلیل خود را بنویسید</label>
            <div className="py-2">
              <textarea
                className="form-control"
                id="message"
                cols="20"
                rows="5"
                required
              ></textarea>
            </div>
            <ButtonDisable
              buttonTagHtml={
                <span className="btn btn-danger opacity-50">
                  رد کردن پیشنهاد
                </span>
              }
            ></ButtonDisable>
          </div>
        </form>
      </>
    );
  };

  const generateTemporaryDateEditPosition = (positionTemporary) => {
    return (
      <>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای ویرایش جایگاه{" "}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>تعداد بنر در جایگاه</td>
                <td>{helpersNumbers.toPersianNum(positionTemporary.count)}</td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        positionTemporary.base_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        positionTemporary.price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>

              <tr>
                <td>نمایش تبلیغ جایگزین</td>
                <td>
                  {positionTemporary.allow_alternative ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>
              {positionTemporary.allow_alternative && (
                <tr>
                  <td> امتیاز تبلیغ بنری جایگزین</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          positionTemporary.score_alternative
                        )
                      )}
                    </span>
                  </td>
                </tr>
              )}

              <tr>
                <td>اندازه جایگاه </td>
                <td>
                  <span className="pl-3">
                    <span>عرض = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        positionTemporary.size.split("-")[0]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                  <span>
                    <span>ارتفاع = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        positionTemporary.size.split("-")[1]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  {positionTemporary.active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>{positionTemporary.created_at}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const generatePosition = () => {
    return (
      <>
        {(position.state ==
          StatePositionConstant.getStatusPositionString()[
            StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
          ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition
                .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
            ]) &&
          generateHtmlTagForAgreeOperatorSuggestion()}

        {(position.state ==
          StatePositionConstant.getStatusPositionString()[
            StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
          ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition
                .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
            ]) && (
          <div className="alert alert-danger">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              دلیل رد شدن جایگاه توسط اپراتور :{" "}
            </p>
            <p className="text-justify" style={{ whiteSpace: "pre-line" }}>
              {position.message}
            </p>
          </div>
        )}

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات جایگاه{" "}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره جایگاه</td>
                <td>{helpersNumbers.toPersianNum(position.ID)}</td>
              </tr>
              <tr>
                <td>تعداد بنر در جایگاه</td>
                <td>{helpersNumbers.toPersianNum(position.count)}</td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(position.base_price)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(position.price)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>حق نمایش دهنده</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        position.publisher_right
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>کمسیسون هایلات</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        position.hilite_commission
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>

              <tr>
                <td>نمایش تبلیغ جایگزین</td>
                <td>
                  {position.allow_alternative ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>

              {position.allow_alternative && (
                <tr>
                  <td>امتیاز تبلیغ بنری جایگزین</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.score_alternative
                        )
                      )}
                    </span>
                  </td>
                </tr>
              )}
              <tr>
                <td>اندازه جایگاه </td>
                <td>
                  <span className="pl-3">
                    <span>عرض = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(position.size.split("-")[0])}
                    </span>
                    <span>px</span>
                  </span>
                  <span>
                    <span>ارتفاع = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(position.size.split("-")[1])}
                    </span>
                    <span>px</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  {position.active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <span
                    className={` badge badge-${getBadgeTypeClassStatePosition(
                      position.state
                    )} `}
                  >
                    {position.state}
                  </span>
                </td>
              </tr>
              <tr>
                <td>شناسه تگ html جایگاه</td>
                <td>{position.tag_html_id}</td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>{position.created_at}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {(position.state ==
          StatePositionConstant.getStatusPositionString()[
            StatePositionConstant.statusPosition.PENDING
          ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
            ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition.CONFIRM
            ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition
                .ALREADY_CONFIRMED_PENDING_FOR_EDIT
            ] ||
          position.state ==
            StatePositionConstant.getStatusPositionString()[
              StatePositionConstant.statusPosition
                .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
            ]) && (
          <div className="pt-2">
            <span>
              <Link
                to={`/positions/independent/${positionID}/edit`}
                className="btn btn-success"
              >
                ویرایش جایگاه
              </Link>
            </span>
          </div>
        )}
        <hr />
        <div>
          {position["temporary"] &&
            generateTemporaryDateEditPosition(position["temporary"])}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="نمایش اطلاعات جایگاه تبلیغات" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/positions/independent/all/web-site-publisher/1"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {generatePosition()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
